
import './App.css';
import React, { useContext } from 'react'
import { useWeb3React } from "@web3-react/core"
import { injected } from './connectors';
import { Contract, getDefaultProvider, providers, utils } from "ethers";
import { config } from "./config";
import abi from "./fixtures/abi.json"; 

import { RegisterStalemate, RegisterWin } from "./Game.js";

import { LoginContext } from "./Contexts/LoginContext";


const provider = getDefaultProvider("ropsten", { alchemy: config.alchemyKey });
new Contract(
  "0xab2fd3b36ba20eeCaea408aE5712726CCf757993",
  abi,
  provider
);


function App() {
  const { active, account, activate } = useWeb3React()

  const { memberPiece, currUserPiece, setIsStaked, isGameOver } = useContext(LoginContext); 


  async function connect () {
    try {
      await activate(injected)
    } catch (ex) {
      console.log(ex)
    }
  }


  // async function disconnect () {
  //   try {
  //     deactivate()
  //   } catch (ex) {
  //     console.log(ex)
  //   }
  // }


  async function stake () {
    try {
      const { ethereum } = window;
      if (typeof ethereum == "undefined") alert("Metamask is not detected");
      await ethereum.enable();
      const provider = new providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new Contract(
        "0xab2fd3b36ba20eeCaea408aE5712726CCf757993",
        abi,
        signer
      );

      const receipt = await contract.stake({ value: utils.parseEther("0.1") })
      setIsStaked("pending")
      await receipt.wait()
      setIsStaked("true")

    } catch (ex) {
      console.log(ex)
    }
  }


  async function claimBack() {
    try {
      const { ethereum } = window;
      if (typeof ethereum == "undefined") alert("Metamask is not detected");
      await ethereum.enable();
      const provider = new providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new Contract(
        "0xab2fd3b36ba20eeCaea408aE5712726CCf757993",
        abi,
        signer
      );

      await contract.claimBack(account)

    } catch (ex) {
      console.log(ex)
    }    
  }


  async function claimWin () {
    try {
      const { ethereum } = window;
      if (typeof ethereum == "undefined") alert("Metamask is not detected");
      await ethereum.enable();
      const provider = new providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new Contract(
        "0xab2fd3b36ba20eeCaea408aE5712726CCf757993",
        abi,
        signer
      );

      await contract.claimWin(account)

    } catch (ex) {
      console.log(ex)
    }    
  }



  
  async function RegisterStalemate2 () {
    try {
      const { ethereum } = window;
      if (typeof ethereum == "undefined") alert("Metamask is not detected");
      await ethereum.enable();
      const provider = new providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new Contract(
        "0xab2fd3b36ba20eeCaea408aE5712726CCf757993",
        abi,
        signer
      );

      let stalemate = RegisterStalemate()
     
      if (stalemate === true) {
        await contract.isStalemate(account)
      }

    } catch (ex) {
      console.log(ex)
    }    
  }

  
  async function RegisterWin2 () {
    try {
      const { ethereum } = window;
      if (typeof ethereum == "undefined") alert("Metamask is not detected");
      await ethereum.enable();
      const provider = new providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new Contract(
        "0xab2fd3b36ba20eeCaea408aE5712726CCf757993",
        abi,
        signer
      );

      let winner = RegisterWin ()
      let p1piece = memberPiece
      let p2piece = currUserPiece

      if ((winner === p1piece && winner !== undefined) || (winner === p2piece && winner !== undefined)) {
        await contract.isWinner(account)
      } else {
        console.log("You are not the winner")
      }

    } catch (ex) {
      console.log(ex)
    }    
  }



  return (
    <div className="container1">        
      
        <div className="horizontal-text">
          Connect and stake to start game:
        </div>

        <div className="horizontal-text">
          If the game is a stalemate:
        </div>

        <div className="horizontal-text">
          If you are the winner:
        </div>


        <div className="horizontal-buttons">      
        <button
          onClick={connect}
          type="button"
          id="connect"
          className="horizontal-text-b"             
        >
          Connect
        </button>
        </div>

        <div className="horizontal-buttons">
        <button
          onClick={RegisterStalemate2}
          type="button"
          id="registerstalemate"
          className="horizontal-text-b"
        >
        Register stalemate
        </button>
        </div>

        <div className="horizontal-buttons">
        <button
          onClick={RegisterWin2}
          type="button"
          id="registerwin"
          className="horizontal-text-b"
        >
        Register win
        </button>
        </div>


      <div>
        <div className="horizontal-buttons">
        <button
          onClick={stake}
          disabled={isGameOver === true}
          type="button"
          id="stake"
          className="horizontal-text-b"
        >
        Stake 0.1 ETH
        </button>
        </div>

        <div className="horizontal-buttons">
        <button
          onClick={claimBack}
          type="button"
          id="claimback"
          className="horizontal-text-b"
        >
        Claim back 0.1 ETH
        </button>
        </div>

        <div className="horizontal-buttons">
        <button
          onClick={claimWin}
          type="button"
          id="claimwin"
          className="horizontal-text-b"
        >
        Claim 0.2 ETH winnings
        </button>
        </div>
      </div>

      {/* <div className="horizontal-buttons">
      <button
        onClick={disconnect}
        type="button"
        id="disconnect"
        className="horizontal-text-b"
      >
      Disconnect
      </button>
      </div> */}

      <div className="horizontal-text-a">
        {active ? <span>Connected with: <b>{account}</b></span> : <span>Status: not connected</span>}
      </div>

    </div>
  );
}

export default App;
